import { Analytics } from "aws-amplify";
import _Vue from "vue";

if (process.env.VUE_APP_PINPOINT_ENABLED === "1") {
  Analytics.configure({
    autoSessionRecord: false,
    AWSPinpoint: {
      appId: process.env.VUE_APP_PINPOINT_APP_ID,
      region: process.env.VUE_APP_COGNITO_REGION,
      mandatorySignIn: false
    }
  });
}

export interface AnalyticsManager {
  enabled: boolean;
  record: (args: any) => Promise<any>;
  update: (args: any) => Promise<any>;
}

export const analytics: AnalyticsManager = {
  enabled: process.env.VUE_APP_PINPOINT_ENABLED === "1",
  record: (args: any) => Analytics.record(args),
  update: (args: any) => Analytics.updateEndpoint(args)
};

export default function AnalyticsPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$analytics = analytics;
}
